import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

import styles from "./style.module.css";

export default class TileTitle extends React.PureComponent {
  render() {
    const { title, noOverlay, overlayText, overlay, children, ...retProps } = this.props;

    if (noOverlay) {
      return (
        <div className={styles.tileTitleWrapper}>
          <Title title={title} override={children} {...retProps} />
        </div>
      );
    }

    return (
      <div className={styles.tileTitleWrapper}>
        <OverlayTrigger
          placement="top"
          trigger={["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top">
              {overlay ? overlay : <div className={styles.popoverList}>{overlayText}</div>}
            </Popover>
          }
        >
          <Title title={title} override={children} {...retProps} />
        </OverlayTrigger>
      </div>
    );
  }
}

class Title extends React.PureComponent {
  render() {
    const { override, title, className, ...retProps } = this.props;
    if (override) {
      return <React.Fragment>{override}</React.Fragment>;
    }
    return (
      <div className={styles.tileTitle + " " + styles.h3 + " " + (className ? className : "")} {...retProps}>
        {title}
      </div>
    );
  }
}
